import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAreaFamily = (props) => /* @__PURE__ */ _jsx("svg", {
	preserveAspectRatio: "none",
	width: "100%",
	height: "100%",
	overflow: "visible",
	style: { display: "block" },
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Frame",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Vector",
				d: "M10 26C10 24.7125 10.438 23.4101 11.5079 22.6939C12.7909 21.8348 14.3365 21.3333 16 21.3333C17.6635 21.3333 19.2091 21.8348 20.4921 22.6939C21.562 23.4101 22 24.7125 22 26",
				stroke: "var(--stroke-0, #9565FD)",
				strokeWidth: 2,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_2",
				d: "M16 18C17.8409 18 19.3333 16.5076 19.3333 14.6667C19.3333 12.8257 17.8409 11.3333 16 11.3333C14.1591 11.3333 12.6667 12.8257 12.6667 14.6667C12.6667 16.5076 14.1591 18 16 18Z",
				stroke: "var(--stroke-0, #9565FD)",
				strokeWidth: 2,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_3",
				d: "M23.3333 14.6667C24.8135 14.6667 26.1887 15.1692 27.3299 16.0299C28.2972 16.7595 28.6667 17.9935 28.6667 19.2051V19.3333",
				stroke: "var(--stroke-0, #9565FD)",
				strokeWidth: 2,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_4",
				d: "M23.3333 11.3333C24.8061 11.3333 26 10.1394 26 8.66667C26 7.19391 24.8061 6 23.3333 6C21.8606 6 20.6667 7.19391 20.6667 8.66667C20.6667 10.1394 21.8606 11.3333 23.3333 11.3333Z",
				stroke: "var(--stroke-0, #9565FD)",
				strokeWidth: 2,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_5",
				d: "M8.66667 14.6667C7.18649 14.6667 5.81128 15.1692 4.67008 16.0299C3.70275 16.7595 3.33333 17.9935 3.33333 19.2051V19.3333",
				stroke: "var(--stroke-0, #9565FD)",
				strokeWidth: 2,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_6",
				d: "M8.66667 11.3333C10.1394 11.3333 11.3333 10.1394 11.3333 8.66667C11.3333 7.19391 10.1394 6 8.66667 6C7.19391 6 6 7.19391 6 8.66667C6 10.1394 7.19391 11.3333 8.66667 11.3333Z",
				stroke: "var(--stroke-0, #9565FD)",
				strokeWidth: 2,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		]
	})
});
export default SvgAreaFamily;
